const initialState = {
  limit: 20,
  page: 1,
  sort: {},
  search: {},
  pagination: {},
};

const paginationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PAGINATION":
      return {
        ...state,
        limit: action.pagination?.limit ?? state.limit,
        page: action.pagination?.page ?? state.page,
        sort: action.pagination?.sort ?? state.sort,
        search: action.pagination?.search ?? state.search,
        filters:action.pagination?.filters?? state.filters
      };
    default:
      return state;
  }
};

export default paginationReducer;
